import React, { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import axios from "axios";

import edit from "../../images/edit.svg";
import Delete from "../../images/delete.svg";
import Logo from "../../images/logo-2.png";
import { useSelector } from "react-redux";
import api from "../../api";
import { Pagination, Stack } from "@mui/material";
import { Loader } from "./loader";
import moment from "moment";
import { Modal } from "react-bootstrap";
import { EditUserData } from "./adminComp/userEditModal";

function AdminPaymentHistory({ adminType }) {
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [data, setData] = useState([]);
  const [noOfUser, setnoOfUser] = useState(0);
  const [loader, setLoader] = useState(false);
  const [searchMail, setSearchMail] = useState("");
  const [resetPage, setResetPage] = useState(false);

  const [selectedData, setSelectedData] = useState({});

  const handleSearch = async () => {
    try {
      if (searchMail) {
        let payload = {
          page: page,
          email: searchMail,
        };
        setLoader(true);
        const res = await api.getPaymentHistoryAdmin(payload);
        console.log(res);
        if (res?.success) {
          setData(res?.history);
          setnoOfUser(res.count);
          setLimit(res.limit);
          setLoader(false);
        } else {
          alert("Email does not exist");
          setLoader(false);
        }
      } else {
        alert("Please insert email for search");
        setLoader(false);
      }
    } catch (error) {
      console.log(error);

      alert("Invalid Email Address");
      setLoader(false);
    }
  };

  useEffect(() => {
    if (searchMail) {
      handleSearch();
    }
  }, [page]);

  return (
    <>
      {/* Begin Page Content */}
      <div className="container-fluid">
        {/* Content Row */}
        <div className="payHistoryPage">
          <div className="row">
            {/* Area Chart */}
            <div className="col">
              <div className="row mx-0 drivers-row">
                <div className="col-12   d-flex justify-content-between pr-0 flex-wrap">
                  <h4 className="color-dark fs-17 dib font-weight-bold mr-5">
                    Search Payment History
                    {/* ({noOfUser}) */}
                  </h4>
                  {/* <a href="#" className="driver-row-link">All</a>
                                 <a href="#" className="driver-row-link">Arbitrators (86)</a>
                                 <a href="#" className="driver-row-link">Mediators (32)</a> */}
                  <div className="searchMadmin">
                    <div className="inputM">
                      <div className="iM">
                        <i className="fa-solid fa-magnifying-glass"></i>
                        <input
                          onChange={(e) => setSearchMail(e.target.value)}
                          type="text"
                          placeholder="Search by email..."
                        />
                      </div>
                      <i
                        className="fa-solid fa-magnifying-glass sIcon"
                        onClick={handleSearch}
                      ></i>
                    </div>
                  </div>
                </div>
              </div>
              {/* table */}
              <Table
                data={data}
                setPage={setPage}
                page={page}
                noOfUser={noOfUser}
                limit={limit}
                adminType={adminType}
              />
            </div>
          </div>
        </div>
      </div>
      {/* /.container-fluid */}
      {loader && <Loader />}
    </>
  );
}
const Table = ({ data, page, setPage, noOfUser, limit, adminType }) => {
  // const authedUser = useSelector(s => s.authedUser.authedUser);
  const handleChange = (event, value) => {
    setPage(value);
  };

  const formatDate = (date) => {
    let dateTemp = moment(date).format("MMMM Do YYYY, h:mm:ss a");
    return dateTemp;
  };

  const checkSubscription = (nextPayment) => {
    let currentDate = new Date();
    let endDate = new Date(nextPayment);

    if (currentDate < endDate) {
      return true;
    } else {
      return false;
    }
  };

  function getInitials(username) {
    if (username) {
      // Split the username into words (assuming space separates the first and last names)
      const nameParts = username.split(" ");

      if (nameParts.length < 2) {
        // If the username doesn't have both a first and last name, return the initials of what is available
        return nameParts[0].charAt(0).toUpperCase(); // Assuming first name is present
      }

      // Extract the first character of the first and last name and return them as uppercase
      const firstInitial = nameParts[0].charAt(0).toUpperCase();
      const lastInitial = nameParts[1].charAt(0).toUpperCase();

      return firstInitial + lastInitial;
    }
  }

  return (
    <>
      <div className="card sortby-box br-10 border-transparent mt-3">
        <div className="card-header br-10  bg-white border-transparent py-3 ">
          <div className="table-responsive">
            <table className="table table-hover drivers-table">
              <thead>
                <tr>
                  <th scope="col" className="">
                    Email
                  </th>
                  <th scope="col" className="">
                    Amount
                  </th>
                  <th scope="col" className="">
                    Type
                  </th>
                  <th scope="col" className="">
                    Paid At
                  </th>
                  {/* <th scope="col" className="">
                    Subscription End
                  </th> */}
                </tr>
              </thead>
              <tbody>
                {data.map((item, key) => (
                  <tr key={key}>
                    <td>
                      <div className="profileM">
                        <div className="profileIco">
                          {getInitials(item?.user?.name) || "-"}
                        </div>
                        {item?.user?.email}
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">
                        {item?.amountPaid}$
                      </div>
                    </td>
                    <td scope="row">
                      <div className="table-text-dark w-max-c db">Monthly</div>
                    </td>
                    <td>
                      <span className="table-text-dark w-max-c db">
                        {formatDate(item?.createdAt)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="d-flex justify-content-center">
            <Stack spacing={2}>
              <Pagination
                count={Math.ceil(noOfUser / limit)}
                page={page}
                onChange={handleChange}
              />
            </Stack>
          </div>
        </div>
      </div>
    </>
  );
};

export default AdminPaymentHistory;
